<template>
  <div class="logos">
    <div class="logos__text">
      <h1 class="logos__title">{{ title }}</h1>
      <!-- <div class="logos__col"> -->
        <p class="logos__paragraph">{{ paragraph }}</p>
      <!-- </div> -->
    </div>

    <div class="logos__grid">
      <LogosItem v-for="(item, index) in items" :key="index" :item="item" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LogosItem from "@/components/LogosItem.vue";

export default {
  name: "Logos",

  components: {
    LogosItem
  },

  props: {
    content: Object
  },

  data() {
    return {
      title: this.content.title,
      paragraph: this.content.paragraph,
      items: this.content.items
    };
  },

  computed: mapState({}),

  watch: {},

  methods: {},

  mounted() {}
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.logos {
  @extend %page-margin-3-v;
  background: $color-dark-grey;

  &__text {
    @extend %page-margin-3;

    display: flex;
    flex-wrap: wrap;
  }

  &__title {
    @include typeface(expanded);
    @include typeset(display-3);

    width: 100%;
    color: white;
    box-sizing: border-box;
    padding-right: rem(24);
    margin-bottom: rem(24);

    @media screen and (min-width: 769px) {
      @include typeset(display-1);
      width: 60%;
    }
  }

  &__col {
    @extend %page-margin-1;
  }

  &__paragraph {
    @include typeset(body-normal);

    color: lighten(black, 40%);

    width: 100%;
    max-width: 40em;
    box-sizing: border-box;

    @media screen and (min-width: 769px) {
      width: 40%;
    }

    @media screen and (min-width: 769px) {
      @include typeset(body-large);
    }
  }

  &__grid {
    @extend %page-margin-1;
    @extend %page-margin-1-v;

    display: flex;
    flex-wrap: wrap;

    // margin: 0 -1%;

    @media screen and (min-width: 1800px) {
      max-width: 1880px;
      margin: 0 auto;
    }

    > * {
      width: 45%;
      margin: 2.5%;

      height: 100px;

      > * {
        padding: 25px;
      }

      @media screen and (min-width: 440px) {
        width: 29%;
        margin: 2%;
        height: 150px;

        > * {
          padding: 40px 25px;
        }
      }
      @media screen and (min-width: 769px) {
        > * {
          padding: 40px 35px;
        }
      }
      @media screen and (min-width: 1024px) {
        width: 21%;
        margin: 2%;
      }
      @media screen and (min-width: 1440px) {
        height: 200px;

        > * {
          padding: 70px 100px;
        }
      }
    }
  }
}
</style>
